import { Trans, useTranslation } from 'react-i18next';
import { Button } from '@/components/ui';
import styles from './UndoBanner.module.css';

export interface PendingUndoItem {
    id: string;
    roleKey: string;
    appRole: string;
}

export interface UndoBannerProps {
    items: PendingUndoItem[];
    onUndo: (id: string) => void;
}

/**
 * EAA-1817: the "vừa xoá — hoàn tác?" strip beneath the editor table.
 * `restoreRoleMap` has NO server-side expiry (see `useRoleEditor.ts`'s
 * `UNDO_WINDOW_MS`) — this banner disappearing is the only thing that ends
 * the window; the id stays restorable via the API after that, this UI just
 * stops offering the shortcut.
 *
 * `role="status"` + `aria-live="polite"` so a screen-reader user is told a
 * link was removed without the announcement stealing focus.
 */
export function UndoBanner({ items, onUndo }: UndoBannerProps) {
    const { t } = useTranslation();
    if (items.length === 0) return null;

    return (
        <div className={styles.undoBanner} role="status" aria-live="polite">
            {items.map((item) => (
                <p key={item.id} className={styles.row}>
                    <Trans
                        i18nKey="console.roleCoverage.undoBanner.message"
                        values={{ appRole: item.appRole, roleKey: item.roleKey }}
                        components={{ strong: <strong /> }}
                    />
                    <Button className={styles.action} onClick={() => onUndo(item.id)}>
                        {t('console.roleCoverage.undoBanner.undoButton')}
                    </Button>
                </p>
            ))}
        </div>
    );
}

export default UndoBanner;
